module.exports = __webpack_public_path__ + "img/jujiayanglaoshequfuwu.094cd88c.png";